import * as React from 'react';
import Typography from '@material-ui/core/Typography/Typography';
import { QuoteModel } from '../../model/autogen/QuoteModel';
import { createChipArray, createChip } from './block-quote';
import { Iif } from "../iif";
import { FileAttachmentList } from "../../components/file-attachment-list";
import { downloadLinkResolver } from "../../pages/brief-item-page";
import * as moment from 'moment'
import './block-quote.css';
import { PersonModel } from '../../model/autogen/PersonModel';
import { TagList, Spacer } from '../../components/utility-components';
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core';
import ExpandMore from "@material-ui/icons/ExpandMore";
import Quote from "@material-ui/icons/FormatQuote";
import { normalizeUrl } from '../../utils/url';

export interface IDisplayQuoteProps {
    quote: QuoteModel;
    author?: PersonModel;
    customDecoration?: JSX.Element;
}

export const DisplayQuote = (props: IDisplayQuoteProps) => {
    const { quote } = props

    return <>
        <ExpansionPanel defaultExpanded={true} style={{ backgroundColor: "#fefefe" }}>
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                    <div style={{ marginRight: "100px" }}>
                        <Typography variant="caption">Date of Transcript</Typography>
                        <Typography gutterBottom>{quote.dateOfQuote === null || quote.dateOfQuote === undefined ? "" : moment(quote.dateOfQuote).format("Do MMMM YYYY")}</Typography>
                    </div>
                    <div>
                        <Typography variant="caption">Transcript Topic</Typography>
                        <Typography gutterBottom variant="h6">{quote.topic}</Typography>
                    </div>
                </div>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <div style={{ width: "100%"}}>
                    {props.author != undefined && <Iif show={true}>
                        <Typography variant="caption" gutterBottom>Transcript By</Typography>
                        <div style={{ marginBottom: "10px" }}>
                            {createChip(quote.person)}
                        </div>
                    </Iif>}
                    <div style={{ float: 'right', width: '50px', height: '50px' }} >
                        {!props.customDecoration && <Quote style={{ color: '#e0e0e0', width: '100%', height: '100%' }} />}
                    </div>
                    <div style={{ float: 'left', width: '50px', height: '50px' }} >
                        {!props.customDecoration && <Quote style={{ color: '#e0e0e0', width: '100%', height: '100%', transform: "scaleX(-1)" }} />}
                    </div>
                    <Typography align="center" variant="caption">Transcript</Typography>
                    <Typography align="center" gutterBottom variant="h6" style={{maxWidth: '100%', wordBreak: "break-word"}}>{quote.phrase}</Typography>
                    <Spacer />
                    {quote.sourceURL && <Typography variant="caption">Link to Transcript</Typography>}
                    {quote.sourceURL && <Typography gutterBottom>
                        <a href={normalizeUrl(quote.sourceURL)} target="_blank">{`${quote.sourceURL}`}</a>
                    </Typography>}
                    <Iif show={quote.subjects !== undefined && quote.subjects.length > 0}>
                        <Typography gutterBottom variant="caption">Subjects of Transcript</Typography>
                        {createChipArray(quote.subjects)}
                    </Iif>
                    <Typography variant="caption">Files</Typography>
                    <FileAttachmentList files={quote.files} downloadLinkResolver={downloadLinkResolver} editing={false} />
                    <Typography variant="caption">Tags</Typography>
                    <TagList tags={quote.tags} />
                </div>
            </ExpansionPanelDetails>
        </ExpansionPanel>

    </>
}



// WEBPACK FOOTER //
// ./src/components/material/display-quote.tsx